import { AddCustomAttribute } from "components/Campaign/CampaignEffects/AddCustomAttribute";
import { GivePointsInternalBased } from "components/Campaign/CampaignEffects/GivePointsInternal/GivePointsInternalBased";
import { GiveReward } from "components/Campaign/CampaignEffects/GiveReward/GiveReward";
import { RemoveCustomAttribute } from "components/Campaign/CampaignEffects/RemoveCustomAttribute";
import { CampaignEffectType } from "types/campaigns";

export function EffectInternal({
  effect,
  fieldName,
}: {
  effect: CampaignEffectType;
  fieldName: string;
}) {
  return (
    <>
      {
        {
          deduct_unit: (
            <GivePointsInternalBased fieldName={`${fieldName}.pointsRule`} />
          ),
          give_points: (
            <GivePointsInternalBased fieldName={`${fieldName}.pointsRule`} />
          ),
          give_reward: <GiveReward fieldName={fieldName} />,
          assign_member_custom_attribute: (
            <AddCustomAttribute fieldName={fieldName} />
          ),
          remove_member_custom_attribute: (
            <RemoveCustomAttribute fieldName={fieldName} />
          ),
        }[effect]
      }
    </>
  );
}
